export enum ProgressItemState {
  None,
  Init,
  Active,
  Done,
}
